import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=0c140e02&scoped=true&"
import script from "./estadisticas.vue?vue&type=script&lang=ts&"
export * from "./estadisticas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c140e02",
  null
  
)

export default component.exports